import isEmptyField from './isEmptyField';
/**
 * @param {string} value
 * @param {string} allValues
 * @param {string} error
 * @returns {string|null}
 */
const code = (value, allValues, error = 'Невалидный код') =>
  !isEmptyField(value) && !/^(\d{5})$/i.test(value) ? error : null;

export default code;
